import React, { useMemo } from 'react';
import ReactSelect from '../ReactSelect';
import { Props } from 'react-select';
import useMakesAndModels from '../../hooks/useMakesAndModels';
import { GroupBase } from 'react-select/dist/declarations/src/types';

export type ModelOption = { label: string; value: string };
type ModelPickerProps<
  IsMulti extends boolean = false,
  Group extends GroupBase<ModelOption> = GroupBase<ModelOption>,
> = Partial<Props<ModelOption, IsMulti, Group>> & {
  modelId?: string;
  makeId?: string;
};

const ModelPicker: React.FC<ModelPickerProps> = (props): JSX.Element => {
  const { modelNames, modelsByMake, makesByModel, loading } =
    useMakesAndModels();
  const options = useMemo(() => {
    if (!props.makeId || !modelsByMake || !modelsByMake[props.makeId]) {
      return [];
    }
    return modelsByMake[props.makeId].map((model) => ({
      label: model.name,
      value: model.id,
    }));
  }, [modelsByMake, props.makeId]);

  const value = useMemo<ModelOption | null>(() => {
    return props.makeId &&
      props.modelId &&
      modelNames &&
      makesByModel &&
      makesByModel[props.modelId]?.id === props.makeId
      ? { label: modelNames[props.modelId], value: props.modelId }
      : null;
  }, [props.makeId, props.modelId, modelNames, makesByModel]);

  return (
    <ReactSelect
      menuPlacement="auto"
      isDisabled={!props.makeId}
      placeholder=""
      {...props}
      styles={{
        ...props.styles,
        menu: (base) => ({
          ...base,
          minWidth: '170px',
        }),
      }}
      value={value}
      options={options}
      isLoading={loading}
    />
  );
};

export default ModelPicker;
